Vue.component('navigation-toggler', require('./../src/components/Navigation/Toggler').default);
Vue.component('navigation-wrapper', require('./../src/components/Navigation/Wrapper').default);

Vue.component('cookie-consent', require('./../src/components/Cookie/CookieConsent').default);
Vue.component('cookie-setup', require('./../src/components/Cookie/CookieSetup').default);
Vue.component('share-buttons', require('./../src/components/ShareButtons').default);
Vue.component('search-form', require('./../src/components/Search/SearchForm').default);
Vue.component('search-trigger', require('./../src/components/Search/SearchTrigger').default);
Vue.component('ssd-paginator', require('./../src/components/Paginator/Select').default);

Vue.component('change-reveal', require('./../src/components/Reveal/Change').default);
Vue.component('toggle-reveal', require('./../src/components/Reveal/Toggle').default);
Vue.component('accordion', require('./../src/components/Reveal/Accordion').default);

Vue.component('store-directory', require('./../src/components/Widgets/StoreDirectory').default);

Vue.component('horizontal-feed', require('./../src/components/Widgets/HorizontalFeed').default);
Vue.component('feed-wrapper', require('./../src/components/Widgets/FeedWrapper').default);